import { writable } from 'svelte/store';
import type { Lobby } from '@blather/shared';

interface LobbyState {
  lobby: Lobby | null;
  loading: boolean;
  error: string | null;
}

export const lobbyStore = writable<LobbyState>({
  lobby: null,
  loading: false,
  error: null,
});

export function updateLobby(lobby: Lobby): void {
  console.log('Lobby updated - phase:', lobby.gameState?.phase, 'players:', lobby.players.length);
  lobbyStore.update((state) => ({ ...state, lobby, error: null }));
}

export function setLobbyError(error: string): void {
  lobbyStore.update((state) => ({ ...state, error, loading: false }));
}

export function setLobbyLoading(loading: boolean): void {
  lobbyStore.update((state) => ({ ...state, loading }));
}

export function clearLobby(): void {
  lobbyStore.set({ lobby: null, loading: false, error: null });
}
